<template>
  <v-card class="project-third-party-works">
    <v-card-title class="pa-0">
      Wykorzystane w projekcie utwory osób trzecich
      <div class="project-third-party-works__details">
        {{ getThirdPartyWorksCount }}
      </div>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="getThirdPartyWorksItems"
      hide-default-footer
      :items-per-page="100"
      class="custom-table mt-6"
      @click:row="showInfoDialog"
    >
      <template #[`item.actions`]="{ item }">
        <v-menu
          bottom
          left
          offset-y
        >
          <template
            v-if="editable"
            #activator="{ on, attrs }"
          >
            <v-btn
              icon
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
          </template>

          <v-list min-width="160">
            <v-list-item
              dense
              @click="showEditDialog(item.id)"
            >
              Edycja
            </v-list-item>

            <v-list-item
              dense
              @click="confirmDeleteThirdPartyWorks(item.id)"
            >
              Usuń
            </v-list-item>
          </v-list>
        </v-menu>
      </template>

      <template #no-data>
        Brak utworów do wyświetlenia
      </template>
    </v-data-table>

    <v-btn
      v-if="editable"
      class="custom-submit-button mt-8"
      color="primary"
      @click="showAddDialog()"
    >
      Dodaj utwór
    </v-btn>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import utils from '@/helpers/utils';
import headers from '@/helpers/tableHeaders';

export default {
  props: {
    editable: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      headers: headers.tpw,
    };
  },

  computed: {
    ...mapGetters('metrics', [
      'getThirdPartyWorksItems',
    ]),

    getThirdPartyWorksCount() {
      return utils.getCounterWithSuffix(this.getThirdPartyWorksItems.length,
      'utwór', 'utwory', 'utworów');
    },
  },

  methods: {
    ...mapActions('metrics', [
      'selectActiveThirdPartyWork',
      'removeThirdPartyWorks',
    ]),

    ...mapActions('dialog', [
      'showDialog',
    ]),

    showEditDialog(id) {
      const dialogParams = {
        header: 'Zapisz utwór',
        component: 'EditThirdPartyWorks',
        props: { id },
      };
      this.showDialog(dialogParams);
    },

    showInfoDialog(item) {
      const dialogParams = {
        header: 'Wykorzystywany utwór',
        component: 'InfoThirdPartyWorks',
        props: { id: item.id },
      };
      this.showDialog(dialogParams);
    },

    showAddDialog() {
      const dialogParams = {
        header: 'Dodawanie utworu',
        text: 'Wypełnij poniższe pola i dodaj wykorzystane w projekcie utwory',
        component: 'AddThirdPartyWorks',
      };
      this.showDialog(dialogParams);
    },

    confirmDeleteThirdPartyWorks(id) {
      this.showDialog({
        header: 'Usuwanie utworu',
        text: '<b>Czy na pewno chcesz usunąć ten utwór?</b> <br/> Nie będzie można cofnąć tej akcji.',
        component: 'Confirm',
        props: {
          confirmText: 'Usuń',
          rejectText: 'Nie usuwaj',
        },
      })
        .then(() => {
          this.removeThirdPartyWorks(id);
        })
        .catch(() => {
          this.clearDialog();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.project-third-party-works {
  padding: 24px 32px;
  &__details {
    font-size: 10px;
    line-height: 15px;
    letter-spacing: 0.5px;
    font-weight: 400;
  }
  &::v-deep td {
    max-width: 230px;
  }
  &::v-deep td:nth-child(3) {
    font-weight:400;
    max-width:unset;
    overflow:auto;
    white-space:pre-wrap;
    word-break:break-word;
  }
}
</style>
